<template>
  <footer class="footer-nav-mobile">
    <div class="footer-top">
      <div class="footer-logo-section">
        <div class="footer-logo-brand-row">
          <img src="@/assets/images/whiteLogo.png" alt="logo" class="footer-logo" />
          <div class="footer-brand">
            <div class="footer-brand-title" style="white-space: pre-line;">{{ $t('footer.name2') }}</div>
          </div>
        </div>
        <div class="footer-contact-card">
          <div class="contact-item">
            <div class="contact-label">{{ $t('footer.contact.wechat') }}</div>
            <div class="contact-value">clarewang23</div>
          </div>
          <div class="contact-item">
            <div class="contact-label">{{ $t('footer.contact.email') }}</div>
            <div class="contact-value">clarewang@btinternet.com</div>
          </div>
          <div class="contact-item">
            <div class="contact-label">{{ $t('footer.contact.phone') }}</div>
            <div class="contact-value">+44 (0) 7887 505508</div>
          </div>
        </div>
      </div>
      <!-- <div class="footer-touch-section">
        <div class="footer-touch-title">{{ $t('footer.title') }}</div>
        <div class="footer-touch-desc"></div>
        <div class="footer-socials">
          <span class="footer-social-icon" @click="goToWechat"><i class="el-icon-chat-dot-round"></i></span>
          <span class="footer-social-icon" @click="goToShare"><i class="el-icon-share"></i></span>
        </div>
      </div> -->
    </div>
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <div class="copyright">
          <p>&copy; {{ currentYear }} Hope Guardianship. All rights reserved.</p>
        </div>
        <!-- <div class="footer-bottom-links">
          <router-link to="/home" class="footer-bottom-link">{{ $t('nav.home') }}</router-link>
          <router-link to="/services" class="footer-bottom-link">{{ $t('nav.services') }}</router-link>
          <router-link to="/about" class="footer-bottom-link">{{ $t('nav.story') }}</router-link>
          <router-link to="/testimonials" class="footer-bottom-link">{{ $t('nav.testimonials') }}</router-link>
          <router-link to="/parents" class="footer-bottom-link">{{ $t('nav.parents') }}</router-link>
          <router-link to="/blog" class="footer-bottom-link">{{ $t('nav.blog') }}</router-link>
          <router-link to="/policies" class="footer-bottom-link active">{{ $t('nav.policies') }}</router-link>
        </div> -->
      </div>
    </div>
    <div v-if="showQrModal" class="qr-modal-mask" @click.self="showQrModal = false">
      <div class="qr-modal-content">
        <img src="@/assets/images/close.png" alt="关闭" class="qr-modal-close" @click="showQrModal = false" />
        <img :src="require('@/assets/images/QR (1).png')" alt="WeChat QR" class="qr-modal-img" />
      </div>
    </div>
  </footer>
</template>

<script>
import { Toast } from 'vant';
export default {
  name: 'FooterNavMobile',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  data() {
    return {
      showQrModal: false
    }
  },
  methods: {
    goToWechat() {
      this.showQrModal = true;
    },
    async goToShare() {
      //移动端复制当前页面链接
      const url = window.location.href;
      
      try {
        // 检查是否支持 Clipboard API
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
          Toast.success(this.$t('footer.shareSuccess'));
        } else {
          // 降级方案：使用传统的复制方法
          this.fallbackCopyTextToClipboard(url);
        }
      } catch (error) {
        console.error('复制失败:', error);
        // 降级方案：使用传统的复制方法
        this.fallbackCopyTextToClipboard(url);
      }
    },
    
    fallbackCopyTextToClipboard(text) {
      try {
        // 创建临时文本区域
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        
        if (successful) {
          Toast.success(this.$t('footer.shareSuccess'));
        } else {
          Toast.fail('复制失败，请手动复制链接');
        }
      } catch (error) {
        console.error('降级复制也失败:', error);
        Toast.fail('复制失败，请手动复制链接');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-nav-mobile {
  width: 100%;
  background: #267E75;
  display: block;

  // 弹窗样式
  .qr-modal-mask {
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qr-modal-content {
    background: #fff;
    border-radius: 40px;
    padding: 0;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .qr-modal-img {
    width: 267px;
    height: 361px;
    border-radius: 40px;
    object-fit: cover;
    display: block;
  }

  .qr-modal-close {
    position: absolute;
    top: -40px;
    right: -14px;
    width: 32px;
    height: 32px;
    cursor: pointer;
    z-index: 10;
  }

  .footer-top {
    width: 100%;
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    gap: 30px;

    .footer-logo-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 30px;

      .footer-logo-brand-row {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        text-align: center;
      }

      .footer-logo {
        width: 60px;
        height: 60px;
      }

      .footer-brand {
        .footer-brand-title {
          color: #fff;
          font-size: 24px;
          font-weight: 600;
          line-height: 30px;
          text-align: center;
        }
      }

      .footer-contact-card {
        background: #FCD980;
        width: 100%;
        max-width: 400px;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 20px;
        box-sizing: border-box;

        .contact-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;

          .contact-label {
            color: #282938;
            font-weight: 500;
            font-size: 16px;
            margin-bottom: 4px;
          }

          .contact-value {
            color: #282938;
            font-size: 14px;
            font-weight: 400;
            word-break: break-all;
            line-height: 1.2;
          }
        }
      }
    }

    .footer-touch-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 16px;

      .footer-touch-title {
        color: #fff;
        font-size: 28px;
        font-weight: 700;
        line-height: 1.2;
      }

      .footer-touch-desc {
        color: #D9D9D9;
        font-size: 16px;
        line-height: 1.4;
      }

      .footer-socials {
        display: flex;
        gap: 20px;

        .footer-social-icon {
          width: 36px;
          height: 36px;
          background: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #267E75;
          font-size: 18px;
        }
      }
    }
  }

  .footer-bottom {
    width: 100%;
    background: #fff;
    padding: 20px;

    .footer-bottom-content {
      display: flex;
      flex-direction: column;
      gap: 20px;
      text-align: center;

      .copyright {
        p {
          color: #282938;
          font-size: 14px;
          margin: 0;
        }
      }

      .footer-bottom-links {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .footer-bottom-link {
          color: #282938;
          text-decoration: none;
          font-size: 16px;
          font-weight: 500;
          transition: color 0.3s;
          padding: 8px 0;

          &.active {
            font-weight: 700;
            color: #267E75;
          }

          &:hover {
            color: #267E75;
          }
        }
      }
    }
  }
}
</style>